import { render, staticRenderFns } from "./signatureItem.vue?vue&type=template&id=534ba197&scoped=true"
import script from "./signatureItem.vue?vue&type=script&lang=js"
export * from "./signatureItem.vue?vue&type=script&lang=js"
import style0 from "./signatureItem.vue?vue&type=style&index=0&id=534ba197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534ba197",
  null
  
)

export default component.exports